/**
 * Escalating reassurance ladder for long silent stretches of a run (no new
 * run events). The CoT header climbs one rung at each quiet-time threshold so
 * the user can tell the agent is still working — and working HARD — rather
 * than the UI being stuck. Thresholds are quiet time since the LAST event,
 * not total run time; any new event resets the ladder. Gaps widen as the
 * ladder climbs so the escalation feels responsive early and calm later.
 *
 * Labels are lowercase suffix fragments: the header keeps its playful gerund
 * and renders these in the trailing metadata, e.g. `Scurrying... (18s ·
 * still thinking)`.
 */
const THINKING_HINTS: ReadonlyArray<{ afterMs: number; label: string }> = [
  { afterMs: 10_000, label: 'still thinking' },
  { afterMs: 25_000, label: 'thinking more' },
  { afterMs: 50_000, label: 'thinking even more' },
  { afterMs: 90_000, label: 'taking some time' },
  { afterMs: 150_000, label: 'still working on it' },
];

/** The hint for a given quiet stretch, or null below the first threshold. */
export function thinkingHintForQuietMs(quietMs: number): string | null {
  let hint: string | null = null;
  for (const step of THINKING_HINTS) {
    if (quietMs >= step.afterMs) hint = step.label;
  }
  return hint;
}
